import React from 'react';
import { Field } from 'redux-form';
import { Col, Row } from 'react-bootstrap';
import { HorizontalFormControl, InfoLabel } from '../../../../common/components';

const SchemeDetails = ({ isViewOnly, onPrefixChange }) => {
  return (
    <Row className="section-item">
      <Col sm={6}>
        <Field
          labelSize={4}
          label="Scheme Name:"
          name={'data.attributes.name'}
          component={isViewOnly ? InfoLabel : HorizontalFormControl}
        />
        <Field
          labelSize={4}
          label="Prefix:"
          disabled={isViewOnly}
          name={'data.attributes.prefix'}
          component={isViewOnly ? InfoLabel : HorizontalFormControl}
          onChange={onPrefixChange}
        />
        <Field
          labelSize={4}
          readOnly={true}
          label="Cover Level:"
          name={'data.attributes.cover_level'}
          component={InfoLabel}
        />
      </Col>
    </Row>
  );
};

export default SchemeDetails;
